import script from "./sub-adjustment.vue?vue&type=script&setup=true&lang=ts"
export * from "./sub-adjustment.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__